export default __webpack_public_path__ + "static/media/security.6f2b005f.svg";